import {Fragment} from "react";

const JTCEmployeeForm = () => (
    <Fragment>
        <h1>JTC Employee Form</h1>
    </Fragment>
)

export default JTCEmployeeForm;